var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{attrs:{"id":"shade"}}),_c('router-view'),(_vm.$store.state.TmDocumentUploadIf)?_c('TmDomcuments'):_vm._e(),(_vm.$store.state.evidenceUpload.shouldKeepAlive)?_c('EvidenceUpload'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }